/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PublishHouseRequestModel model module.
 * @module model/PublishHouseRequestModel
 * @version v1.0.0
 */
class PublishHouseRequestModel {
    /**
     * Constructs a new <code>PublishHouseRequestModel</code>.
     * @alias module:model/PublishHouseRequestModel
     * @param name {String} Name (required)
     */
    constructor(name) { 
        
        PublishHouseRequestModel.initialize(this, name);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name) { 
        obj['name'] = name;
    }

    /**
     * Constructs a <code>PublishHouseRequestModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PublishHouseRequestModel} obj Optional instance to populate.
     * @return {module:model/PublishHouseRequestModel} The populated <code>PublishHouseRequestModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PublishHouseRequestModel();

            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
            if (data.hasOwnProperty('supplierId')) {
                obj['supplierId'] = ApiClient.convertToType(data['supplierId'], 'String');
            }
        }
        return obj;
    }


}

/**
 * code
 * @member {String} code
 */
PublishHouseRequestModel.prototype['code'] = undefined;

/**
 * Description
 * @member {String} description
 */
PublishHouseRequestModel.prototype['description'] = undefined;

/**
 * Name (required)
 * @member {String} name
 */
PublishHouseRequestModel.prototype['name'] = undefined;

/**
 * seq
 * @member {Number} seq
 */
PublishHouseRequestModel.prototype['seq'] = undefined;

/**
 * supplier Id
 * @member {String} supplierId
 */
PublishHouseRequestModel.prototype['supplierId'] = undefined;






export default PublishHouseRequestModel;

